import { useState } from 'react';
import { Check, Copy, Export } from '@phosphor-icons/react';
import Modal from '../../../shared/components/Modal';
import {
  copyPublicShareUrl,
  openNativeShare,
} from '../services/publicShareService';

type ShareModalProps = {
  share: {
    place: Record<string, any>;
    token: string;
    url: string;
  };
  onCancel: () => void;
  onComplete: (method: 'copied' | 'shared') => void;
  t: any;
};

export default function ShareModal({ share, onCancel, onComplete, t }: ShareModalProps) {
  const [pending, setPending] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  const copy = async () => {
    setError('');
    try {
      await copyPublicShareUrl(share.url);
      setCopied(true);
      onComplete('copied');
    } catch {
      setError(t.errorShare);
    }
  };

  const nativeShare = async () => {
    setError('');
    setPending(true);
    try {
      await openNativeShare(share.place.name, t.sharePlacePublic, share.url);
      onComplete('shared');
    } catch (shareError: any) {
      if (shareError?.name !== 'AbortError') setError(t.errorShare);
      setPending(false);
    }
  };

  return (
    <Modal onClose={onCancel} label={t.share}>
      <div className="share-modal">
        <div className="modal-head">
          <span className="eyebrow coral">{t.share}</span>
          <h2>{share.place.name}</h2>
          <p>{t.shareModalText}</p>
        </div>
        <div className="share-link-preview">
          <span>{share.url}</span>
          <button type="button" onClick={copy} aria-label={t.copyShareLink}>
            {copied ? <Check weight="bold" /> : <Copy />}
          </button>
        </div>
        {error && <div className="form-error">{error}</div>}
        <div className="share-modal-actions">
          {Boolean((navigator as any).share) && (
            <button type="button" className="primary" disabled={pending} onClick={nativeShare}>
              <Export />{pending ? t.pleaseWait : t.share}
            </button>
          )}
          <button type="button" className="secondary" onClick={copy}>
            {copied ? <Check weight="bold" /> : <Copy />}{copied ? t.copied : t.copyShareLink}
          </button>
        </div>
      </div>
    </Modal>
  );
}
